module.exports = __webpack_public_path__ + "static/media/capstone_permissions.81fc550b.yaml";